import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { CheckCircle2, ShieldAlert } from "lucide-react";
import { api, errMsg } from "@/lib/api";
import { PageShell } from "@/components/Shell";
import { CardVisual, eurC, slvx } from "@/components/wallet/CardVisual";
import { TxList } from "@/components/wallet/MyCard";

export default function WalletScanPage() {
  const { qid } = useParams();
  const [d, setD] = useState(null);
  const [err, setErr] = useState("");
  useEffect(() => {
    api.get(`/wallet/q/${qid}`).then(({ data }) => setD(data)).catch((e) => setErr(errMsg(e)));
  }, [qid]);
  return (
    <PageShell title="Verifica DoctorSelvix Card" testid="wallet-scan-page">
      {err && <p className="flex items-center gap-2 text-sm text-rose-700" data-testid="wallet-scan-error"><ShieldAlert className="h-5 w-5" />{err}</p>}
      {d?.restricted && (
        <p className="flex items-center gap-2 text-sm font-semibold" data-testid="wallet-scan-restricted">
          {d.valid ? <><CheckCircle2 className="h-5 w-5 text-emerald-600" />Carta DoctorSelvix valida.</> : <><ShieldAlert className="h-5 w-5 text-rose-600" />Carta non attiva.</>}
        </p>
      )}
      {d && !d.restricted && (
        <div className="grid max-w-5xl gap-6 lg:grid-cols-2" data-testid="wallet-scan-details">
          <CardVisual card={d.card} name={d.holder.name} qrSrc={d.viewer_is_admin ? `${process.env.REACT_APP_BACKEND_URL}/api/superadmin/wallet/cards/${d.card.id}/qr.svg` : `${process.env.REACT_APP_BACKEND_URL}/api/wallet/me/qr.svg`} />
          <div className="glass space-y-3 rounded-3xl p-5 text-sm">
            <p><b>{d.holder.name}</b> · {d.holder.email}</p>
            <p>Tessera {d.card.card_number} · Wallet {d.wallet.public_wallet_id} · {d.valid ? "attiva" : "sospesa"}</p>
            <p className="font-display text-2xl font-extrabold" data-testid="wallet-scan-balance">{slvx(d.wallet.balance_cents)} <span className="text-sm font-normal text-slate-500">({eurC(d.eur_value_cents)})</span></p>
            <p className="text-xs text-slate-500">La scansione serve solo a identificare la carta: ricariche e rettifiche si fanno dalla sezione Gestione carte del pannello Super Admin.</p>
            <TxList items={d.transactions} />
          </div>
        </div>
      )}
    </PageShell>
  );
}
